export default __webpack_public_path__ + "static/media/contacts-gray.6768278a.svg";